module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/products/product-detail-general/product-detail-general.component.scss
// module id = ./libs/atenea-cms-brand/src/products/product-detail-general/product-detail-general.component.scss
// module chunks = main